import { MemberList } from '@/features/members/MemberList'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/members')({
  component: MemberList,
})
